import React from "react";

function Error404({...r}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 486 417" {...r} >
      <path
        fill="#FDB727"
        fillRule="evenodd"
        d="M28.393 228.525l-4.69 1.486-1.485-4.696a2.299 2.299 0 00-2.89-1.502 2.308 2.308 0 00-1.5 2.893l1.487 4.695-4.69 1.488a2.304 2.304 0 001.39 4.392l4.689-1.486 1.484 4.693a2.306 2.306 0 002.195 1.609 2.304 2.304 0 002.195-2.999l-1.485-4.696 4.69-1.485a2.306 2.306 0 001.499-2.892 2.297 2.297 0 00-2.89-1.5z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#081FA0"
        fillRule="evenodd"
        d="M397.016 54.995a5.422 5.422 0 01-5.023 5.79 5.423 5.423 0 01-.757-10.818 5.421 5.421 0 015.78 5.028z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#EAEBFF"
        fillRule="evenodd"
        d="M425.222 363.401a5.423 5.423 0 01-5.024 5.789 5.42 5.42 0 01-.757-10.817 5.42 5.42 0 015.781 5.028zM62.891 89.745a5.423 5.423 0 01-5.023 5.79 5.423 5.423 0 01-.757-10.818 5.422 5.422 0 015.78 5.028z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#126FFF"
        fillRule="evenodd"
        d="M76.556 343.532a1.717 1.717 0 00-2.157-1.12l-3.502 1.111-1.11-3.508a1.715 1.715 0 00-2.157-1.12 1.72 1.72 0 00-1.118 2.16l1.109 3.505-3.502 1.111a1.72 1.72 0 001.036 3.279l3.502-1.11 1.11 3.505a1.721 1.721 0 001.638 1.202 1.722 1.722 0 001.638-2.242l-1.11-3.503 3.505-1.11a1.722 1.722 0 001.118-2.16z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#EAEBFF"
        fillRule="evenodd"
        d="M471.431 182.813a1.715 1.715 0 00-2.157-1.119l-3.502 1.11-1.11-3.508a1.715 1.715 0 00-2.157-1.12 1.722 1.722 0 00-1.119 2.16l1.11 3.506-3.502 1.11a1.72 1.72 0 00.519 3.361c.17 0 .345-.026.517-.082l3.502-1.11 1.109 3.506a1.722 1.722 0 002.158 1.119 1.721 1.721 0 001.118-2.16l-1.109-3.503 3.505-1.11a1.721 1.721 0 001.118-2.16z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#126FFF"
        fillRule="evenodd"
        d="M202.395 22.094a1.715 1.715 0 00-2.157-1.12l-3.502 1.111-1.109-3.508a1.716 1.716 0 00-2.158-1.12 1.72 1.72 0 00-1.118 2.16l1.109 3.506-3.502 1.11a1.722 1.722 0 00.519 3.361c.171 0 .345-.026.518-.082l3.502-1.11 1.109 3.506a1.722 1.722 0 002.157 1.12 1.722 1.722 0 001.119-2.16l-1.109-3.504 3.504-1.11a1.72 1.72 0 001.118-2.16z"
        clipRule="evenodd"
      ></path>
      <ellipse
        cx="251.678"
        cy="223.703"
        stroke="#F2F2F2"
        strokeDasharray="2 8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        opacity="0.4"
        rx="173.571"
        ry="173.75"
      ></ellipse>
      <ellipse
        cx="251.678"
        cy="223.703"
        stroke="#F2F2F2"
        strokeDasharray="2 8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        opacity="0.6"
        rx="138.857"
        ry="139"
      ></ellipse>
      <g clipPath="url(#error-a)">
        <rect
          width="139"
          height="17.357"
          x="216.964"
          y="154.203"
          fill="#CCC"
          rx="4"
          transform="rotate(90 216.964 154.203)"
        ></rect>
        <rect
          width="139"
          height="17.357"
          x="303.75"
          y="154.203"
          fill="#CCC"
          rx="4"
          transform="rotate(90 303.75 154.203)"
        ></rect>
        <rect
          width="137.857"
          height="33.75"
          x="182.75"
          y="163.391"
          fill="#FDB727"
          stroke="#EF9B30"
          rx="3.5"
        ></rect>
        <rect
          width="137.857"
          height="33.75"
          x="182.75"
          y="215.516"
          fill="#FDB727"
          stroke="#EF9B30"
          rx="3.5"
        ></rect>
        <path
          fill="#FEFEFE"
          d="M229.982 197.641l-8.678-34.75h17.357l8.678 34.75h-17.357zm0 52.125l-8.678-34.75h17.357l8.678 34.75h-17.357z"
        ></path>
        <path
          fill="#FEFEFE"
          fillRule="evenodd"
          d="M195.268 197.641h17.357l-8.679-34.75h-17.357l8.679 34.75zm0 52.125h17.357l-8.679-34.75h-17.357l8.679 34.75z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#FEFEFE"
          d="M264.697 197.641l-8.679-34.75h17.357l8.679 34.75h-17.357zm0 52.125l-8.679-34.75h17.357l8.679 34.75h-17.357z"
        ></path>
        <path
          fill="#FEFEFE"
          fillRule="evenodd"
          d="M299.411 197.641h17.357l-8.679-34.75h-17.357l8.679 34.75zm0 52.125h17.357l-8.679-34.75h-17.357l8.679 34.75z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <clipPath id="error-a">
          <path
            fill="#fff"
            d="M0 0h138.857v139H0z"
            transform="translate(182.25 154.203)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Error404;